import React from 'react';
// logic
import useCarriersList from './components/useCarriersList';
import useCarriersFilters from './components/useCarriersFilters';
// components
import CarriersListToolbar from './carriersListToolbar';
import CarriersList from './components/carriersList';
import ToolbarWithNoPortal from './toolbarWithNoPortal';
import styled from 'styled-components';
import PageContent from 'modules/emergencies/components/ui/page/pageContent';

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const CarriersListPage = () => {
  const filtersData = useCarriersFilters();
  const { selectedFilters } = filtersData;
  const carriersListData = useCarriersList({ selectedFilters });
  const { lastUpdate } = carriersListData;

  return (
    <Layout>
      <ToolbarWithNoPortal>
        <CarriersListToolbar lastUpdate={lastUpdate} filtersData={filtersData} />
      </ToolbarWithNoPortal>
      <PageContent>
        <CarriersList carriersListData={carriersListData} />
      </PageContent>
    </Layout>
  );
};

export default CarriersListPage;
